import axios from "axios";
import { NotificationsResponse, NotificationSetting, UpdateNotificationSettingRequest, NotificationsCorporateResponse } from "./dto/Notification";

// 通知一覧取得
export const getNotifications = async (): Promise<NotificationsResponse[]> => {
  const res = await axios.get<NotificationsResponse[]>(`/api/notification`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// 通知一覧取得（法人）
export const getCorporateNotifications = async (): Promise<NotificationsCorporateResponse[]> => {
  const res = await axios.get<NotificationsCorporateResponse[]>(`/api/notification/corporate`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// 通知既読更新
export const updateReadNotifications = async (
): Promise<NotificationsResponse[]> => {
  const res = await axios.get<NotificationsResponse[]>(
    `/api/notification/read`,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
};

// 通知一覧取得
export const getNotificationSetting = async (): Promise<NotificationSetting> => {
  const res = await axios.get<NotificationSetting>("/api/notification/setting", {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// 通知設定更新
export const updateNotificationSetting = async (req: UpdateNotificationSettingRequest
  ): Promise<NotificationSetting> => {
    const res = await axios.put<NotificationSetting>("/api/notification/setting", req, {
      headers: { "Content-Type": "application/json" },
    });
    return res.data;
};